import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";
import { Button } from "@covertree/ui";
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { resetExternalCoverageData } from "@redux/coverages/coveragesSlice";
import { moveBackInPathname } from "@utils";
import useAppDispatch from "@redux/hooks/useAppDispatch";
import { resetEventSlice } from "@redux/event/eventSlice";

export function EventAdded() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const handleClose = () => {
    dispatch(resetExternalCoverageData());
    dispatch(resetEventSlice());
    navigate(
      {
        pathname: moveBackInPathname(location.pathname, 4),
        search: createSearchParams(searchParams).toString(),
      },
      { replace: true }
    );
  };

  return (
    <Grid
      container
      display="flex"
      flexDirection="column"
      gap={4}
      alignItems="flex-start"
      justifyContent="space-around">
      <img
        src="/images/icons/checkmark.webp"
        alt="success"
        width={80}
        height={80}
      />
      <Grid item xs={12}>
        <Typography fontSize={theme.spacing(4)}>
          New Policy Event Added
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography fontSize={theme.spacing(2.5)}>
          Policy Event has been successfully added to the system.
        </Typography>
      </Grid>
      <Button onClick={handleClose}>Close</Button>
    </Grid>
  );
}
